import React, { useContext, useState } from "react";
import Header from "./header";
import Footer from "./footer";
import Counter from "./countertext";
import { Link } from 'react-router-dom';
import PricingPlanBasic from "./Pricingplan-online-basic";
import PricingPlanPro from "./Pricingplan-online-pro";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";

function Onlineaccounting() {


    const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();

    const toggleQuestion = (questionId) => {
        setActiveQuestion((prev) => (prev === questionId ? null : questionId));
    };
    const [isChecked, setIsChecked] = useState(true);

    const handleToggleChange = () => {
        setIsChecked(!isChecked);
    };

    const [selectedOption, setSelectedOption] = useState("option1");
    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };
    const [isFormVisible, setIsFormVisible] = useState(false);

    const toggleFormVisibility = () => {
        setIsFormVisible(!isFormVisible);
    };

    const tenures = [

        {
            duration: "yearly",
            label: "1 Year",
            price: "12251.00",
            yearlyPrice: "30628.00",
            savings: "Save 60%",

        },
        {
            duration: "Monthly",
            label: "1 Month",
            price: "1451.00",
            yearlyPrice: "2902.00",
            savings: "Save 50%",

        },
        {
            duration: "Quarterly",
            label: "3 Months",
            price: "3251.00",
            yearlyPrice: "6502.00",
            savings: "Save 50%",

        },
        {
            duration: "Half-yearly",
            label: "6 Months",
            price: "7251.00",
            yearlyPrice: "16113.00",
            savings: "Save 55%",

        },

        {
            duration: "yearly",
            label: "2 Years",
            price: "24502.00",
            yearlyPrice: "61255.00",
            savings: "Save 60%",

        },



    ];
    const tenures1 = [
        {
            duration: "yearly",
            label: "1 Year",
            price: "15251.00",
            yearlyPrice: "38128.00",
            savings: "Save 60%",
        },
        {
            duration: "Monthly",
            label: "1 Month",
            price: "1851.00",
            yearlyPrice: "3702.00",
            savings: "Save 50%",
        },
        {
            duration: "Quarterly",
            label: "3 Months",
            price: "4251.00",
            yearlyPrice: "8502.00",
            savings: "Save 50%",
        },
        {
            duration: "Half-yearly",
            label: "6 Months",
            price: "8251.00",
            yearlyPrice: "18335.00",
            savings: "Save 55%",
        },

        {
            duration: "yearly",
            label: "2 Years",
            price: "30502.00",
            yearlyPrice: "76255.00",
            savings: "Save 60%",
        },
    ];
    const tenures2 = [
        {
            duration: "yearly",
            label: "1 Year",
            price: "15251.00",
            yearlyPrice: "38128.00",
            savings: "Save 60%",
        },
        {
            duration: "Monthly",
            label: "1 Month",
            price: "1651.00",
            yearlyPrice: "3302.00",
            savings: "Save 50%",
        },
        {
            duration: "Quarterly",
            label: "3 Months",
            price: "5251.00",
            yearlyPrice: "10502.00",
            savings: "Save 50%",
        },
        {
            duration: "Half-yearly",
            label: "6 Months",
            price: "8251.00",
            yearlyPrice: "18335.00",
            savings: "Save 55%",
        },

        {
            duration: "yearly",
            label: "2 Years",
            price: "30502.00",
            yearlyPrice: "76255.00",
            savings: "Save 60%",
        },
    ];



    const tenures3 = [
        {
            duration: "yearly",
            label: "1 Year",
            price: "18251.00",
            yearlyPrice: "45628.00",
            savings: "Save 60%",
        },
        {
            duration: "monthly",
            label: "1 Month",
            price: "2251.00",
            yearlyPrice: "4502.00",
            savings: "Save 50%",
        },
        {
            duration: "Quarterly",
            label: "3 Months",
            price: "6251.00",
            yearlyPrice: "12502.00",
            savings: "Save 50%",
        },
        {
            duration: "Half-yearly",
            label: "6 Months",
            price: "11251.00",
            yearlyPrice: "25002.00",
            savings: "Save 55%",
        },
        {
            duration: "yearly",
            label: "2 Years",
            price: "36502.00",
            yearlyPrice: "91255.00",
            savings: "Save 60%",
        },
    ];





    const tenures4 = [
        {
            duration: "yearly",
            label: "1 Year",
            price: "31251.00",
            yearlyPrice: "78128.00",
            savings: "Save 60%",
        },
        {
            duration: "monthly",
            label: "1 Month",
            price: "3551.00",
            yearlyPrice: "7102.00",
            savings: "Save 50%",
        },
        {
            duration: "Quarterly",
            label: "3 Months",
            price: "9251.00",
            yearlyPrice: "18502.00",
            savings: "Save 50%",
        },
        {
            duration: "Half-yearly",
            label: "6 Months",
            price: "18251.00",
            yearlyPrice: "40557.00",
            savings: "Save 55%",
        },
        {
            duration: "yearly",
            label: "2 Years",
            price: "62502.00",
            yearlyPrice: "156255.00",
            savings: "Save 60%",
        },
    ];




    const tenures5 = [
        {
            duration: "yearly",
            label: "1 Year",
            price: "41251.00",
            yearlyPrice: "103128.00",
            savings: "Save 60%",
        },
        {
            duration: "monthly",
            label: "1 Month",
            price: "4751.00",
            yearlyPrice: "9502.00",
            savings: "Save 50%",
        },
        {
            duration: "Quarterly",
            label: "3 Months",
            price: "12251.00",
            yearlyPrice: "24502.00",
            savings: "Save 50%",
        },
        {
            duration: "Half-yearly",
            label: "6 Months",
            price: "23251.00",
            yearlyPrice: "51668.00",
            savings: "Save 55%",
        },
        {
            duration: "yearly",
            label: "2 Years",
            price: "82502.00",
            yearlyPrice: "206255.00",
            savings: "Save 60%",
        },
    ];



    const tenures6 = [
        {
            label: "1 Year",
            price: "54251.00",
            yearlyPrice: "1135628.00",
            savings: "Save 60%",
            duration: "yearly",
        },
        {
            label: "1 Month",
            price: "6751.00",
            yearlyPrice: "13502.00",
            savings: "Save 7102",
            duration: "monthly",
        },
        {
            label: "3 Months",
            price: "17251.00",
            yearlyPrice: "34502.00",
            savings: "Save 50%",
            duration: "Quarterly",
        },
        {
            label: "6 Months",
            price: "31251.00",
            yearlyPrice: "69446.00",
            savings: "Save 55%",
            duration: "Half-yearly",
        },
        {
            label: "2 Years",
            price: "108502.00",
            yearlyPrice: "271255.00",
            savings: "Save 60%",
            duration: "yearly",
        },
    ];




    const tenures7 = [
        {
            label: "1 Year",
            price: "70251.00",
            yearlyPrice: "175628.00",
            savings: "Save 60%",
            duration: "Yearly"
        },
        {
            label: "1 Month",
            price: "7751.00",
            yearlyPrice: "15502.00",
            savings: "Save 50%",
            duration: "Monthly"
        },
        {
            label: "3 Month",
            price: "22251.00",
            yearlyPrice: "44502.00",
            savings: "Save 50%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "39251.00",
            yearlyPrice: "87244.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "140502.00",
            yearlyPrice: "351255.00",
            savings: "Save 60%",
            duration: "Yearly"
        }
    ];



    const tenures8 = [
        {
            label: "1 Year",
            price: "85251.00",
            yearlyPrice: "2213128.00",
            savings: "Save 60%",
            duration: "Yearly"
        },
        {
            label: "1 Month",
            price: "9551.00",
            yearlyPrice: "19120.00",
            savings: "Save 7102",
            duration: "Monthly"
        },
        {
            label: "3 Month",
            price: "27251.00",
            yearlyPrice: "54502.00",
            savings: "Save 50%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "48251.00",
            yearlyPrice: "107223.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "170502.00",
            yearlyPrice: "426255.00",
            savings: "Save 60%",
            duration: "Yearly"
        }
    ];



    const tenures9 = [
        {
            label: "1 Year",
            price: "111251.00",
            yearlyPrice: "278128.00",
            savings: "Save 60%",
            duration: "yearly"
        },
        {
            label: "1 Month",
            price: "13251.00",
            yearlyPrice: "26502.00",
            savings: "Save 50%",
            duration: "Monthy"
        },
        {
            label: "3 Month",
            price: "35251.00",
            yearlyPrice: "70502.00",
            savings: "Save 50%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "52251.00",
            yearlyPrice: "138334.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "222502.00",
            yearlyPrice: "556255.00",
            savings: "Save 60%",
            duration: "yearly"
        }
    ];

    const tenures00 = [
        {
            label: "1 Year",
            price: "7251.00",
            yearlyPrice: "18128.00",
            savings: "Save 60%",
            duration: "yearly"
        },
        {
            label: "1 Month",
            price: "851.00",
            yearlyPrice: "1702.00",
            savings: "Save 50%",
            duration: "Monthy"
        },
        {
            label: "3 Month",
            price: "2251.00",
            yearlyPrice: "4502.00",
            savings: "Save 55%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "4251.00",
            yearlyPrice: "9447.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "14502.00",
            yearlyPrice: "36255.00",
            savings: "Save 60%",
            duration: "yearly"
        }
    ];



    const tenures01 = [
        {
            label: "1 Year",
            price: "10251.00",
            yearlyPrice: "25628.00",
            savings: "Save 60%",
            duration: "yearly"
        },
        {
            label: "1 Month",
            price: "1251.00",
            yearlyPrice: "2502.00",
            savings: "Save 50%",
            duration: "Monthy"
        },
        {
            label: "3 Month",
            price: "3251.00",
            yearlyPrice: "6502.00",
            savings: "Save 50%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "5251.00",
            yearlyPrice: "11669.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "20502.00",
            yearlyPrice: "51255.00",
            savings: "Save 60%",
            duration: "yearly"
        }
    ];



    const tenures02 = [
        {
            label: "1 Year",
            price: "10251.00",
            yearlyPrice: "25628.00",
            savings: "Save 60%",
            duration: "yearly"
        },
        {
            label: "1 Month",
            price: "1251.00",
            yearlyPrice: "2502.00",
            savings: "Save 50%",
            duration: "Monthy"
        },
        {
            label: "3 Month",
            price: "3251.00",
            yearlyPrice: "6502.00",
            savings: "Save 50%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "5251.00",
            yearlyPrice: "11669.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "20502.00",
            yearlyPrice: "",
            savings: "Save 60%",
            duration: "yearly"
        }
    ];



    const tenures03 = [
        {
            label: "1 Year",
            price: "12251.00",
            yearlyPrice: "30628.00",
            savings: "Save 60%",
            duration: "yearly"
        },
        {
            label: "1 Month",
            price: "1451.00",
            yearlyPrice: "2902.00",
            savings: "Save 50%",
            duration: "Monthy"
        },
        {
            label: "3 Month",
            price: "4251.00",
            yearlyPrice: "8502.00",
            savings: "Save 50%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "7251.00",
            yearlyPrice: "16113.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "24502.00",
            yearlyPrice: "61255.00",
            savings: "Save 60%",
            duration: "yearly"
        }
    ];



    const tenures04 = [
        {
            label: "1 Year",
            price: "21251.00",
            yearlyPrice: "53128.00",
            savings: "Save 60%",
            duration: "yearly"
        },
        {
            label: "1 Month",
            price: "2251.00",
            yearlyPrice: "4502.00",
            savings: "Save 50%",
            duration: "Monthy"
        },
        {
            label: "3 Month",
            price: "6251.00",
            yearlyPrice: "12502.00",
            savings: "Save 50%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "12251.00",
            yearlyPrice: "27224.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "42502.00",
            yearlyPrice: "106255.00",
            savings: "Save 60%",
            duration: "yearly"
        }
    ];



    const tenures05 = [
        {
            label: "1 Year",
            price: "27251.00",
            yearlyPrice: "68128.00",
            savings: "Save 60%",
            duration: "yearly"
        },
        {
            label: "1 Month",
            price: "2951.00",
            yearlyPrice: "5902.00",
            savings: "Save 50%",
            duration: "Monthy"
        },
        {
            label: "3 Month",
            price: "8251.00",
            yearlyPrice: "16502.00",
            savings: "Save 50%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "15251.00",
            yearlyPrice: "33891.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "54502.00",
            yearlyPrice: "136255.00",
            savings: "Save 60%",
            duration: "yearly"
        }
    ];



    const tenures06 = [
        {
            label: "1 Year",
            price: "36251.00",
            yearlyPrice: "90628.00",
            savings: "Save 60%",
            duration: "yearly"
        },
        {
            label: "1 Month",
            price: "4251.00",
            yearlyPrice: "8502.00",
            savings: "Save 50%",
            duration: "Monthy"
        },
        {
            label: "3 Month",
            price: "11251.00",
            yearlyPrice: "22502.00",
            savings: "Save 50%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "20251.00",
            yearlyPrice: "45002.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "72502.00",
            yearlyPrice: "181255.00",
            savings: "Save 60%",
            duration: "yearly"
        }
    ];



    const tenures07 = [
        {
            label: "1 Year",
            price: "46251.00",
            yearlyPrice: "115628.00",
            savings: "Save 60%",
            duration: "yearly"
        },
        {
            label: "1 Month",
            price: "5251.00",
            yearlyPrice: "10502.00",
            savings: "Save 50%",
            duration: "Monthy"
        },
        {
            label: "3 Month",
            price: "14251.00",
            yearlyPrice: "28502.00",
            savings: "Save 50%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "26251.00",
            yearlyPrice: "58335.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "92502.00",
            yearlyPrice: "231255.00",
            savings: "Save 60%",
            duration: "yearly"
        }
    ];



    const tenures08 = [
        {
            label: "1 Year",
            price: "56251.00",
            yearlyPrice: "140628.00",
            savings: "Save 60%",
            duration: "yearly"
        },
        {
            label: "1 Month",
            price: "7251.00",
            yearlyPrice: "14502.00",
            savings: "Save 50%",
            duration: "Monthy"
        },
        {
            label: "3 Month",
            price: "18251.00",
            yearlyPrice: "36502.00",
            savings: "Save 50%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "32251.00",
            yearlyPrice: "71668.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "112502.00",
            yearlyPrice: "281255.00",
            savings: "Save 60%",
            duration: "yearly"
        }
    ];



    const tenures09 = [
        {
            label: "1 Year",
            price: "76251.00",
            yearlyPrice: "190628.00",
            savings: "Save 60%",
            duration: "yearly"
        },
        {
            label: "1 Month",
            price: "8251.00",
            yearlyPrice: "16502.00",
            savings: "Save 50%",
            duration: "Monthy"
        },
        {
            label: "3 Month",
            price: "23251.00",
            yearlyPrice: "46502.00",
            savings: "Save 50%",
            duration: "Quarterly"
        },
        {
            label: "6 Month",
            price: "42251.00",
            yearlyPrice: "93890.00",
            savings: "Save 55%",
            duration: "Half-yearly"
        },
        {
            label: "2 Year",
            price: "152502.00",
            yearlyPrice: "381255.00",
            savings: "Save 60%",
            duration: "yearly"
        }
    ];


    const [receivedData, setReceivedData] = useState(null);

    const handleDataFromChild = (data) => {
        console.log("Data received from child:", data);
        setReceivedData(data);
    };
   const { services, loading, error } = useContext(ServicesContext);  
   if (loading) {
      return <div>Loading...</div>;  // Show loading state while fetching data
  }

  if (error) {
       return <div>{error}</div> // Show error state if there was an issue fetching data
  }
   const service = services.find(s => s.service_id === 18);


const handleBannerClick = () => {
  const scrollToElement = document.querySelector(".pricing-area");
 

  // 1️⃣ Scroll to .price-heading
  if (scrollToElement) {
    scrollToElement.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }

};

    return (



        <>

                <div className="hero-section">
             <div className="container">
               <div className="row hero-row">
           
                 <div className="col-lg-8 hero-left">
                          <div class="title title2">
                       <h1 class="sk-text-color">Online Accounting and Bookkeeping Service</h1>
           
           
           <p className="pdrl-text">Start with Only <span className="text-color"> Rs.{service?.price}/- </span><span></span> </p>
                  
           
                    <p className="pd-text">
                  Looking for reliable accounting services? We offer comprehensive online accounting solutions for businesses and professionals. From bookkeeping and tax filing to financial planning, our expert team ensures accuracy, compliance, and smooth financial management so you can focus on growing your business.
                   </p>
           
                   <div className="btn-group">
                                                       <Link to="/contactus" className="theme-btn-3 btn-color ">
                                                           Schedule A Call <span><i className="fa-solid fa-arrow-right"></i></span>
                                                       </Link>
                                   </div>
                                   <div className="space30"></div>
           
                   <div className="hero-link">
                     <a href="/gst-registration">Know more about Online Accounting and Bookkeeping Service</a>
                   </div>
                   <div className="banner" onClick={handleBannerClick}>
                                      <img src="assets/icons/banner.svg" alt="" />
                                   </div>
                                   </div>
                 </div>
           
                 <div className="col-lg-4 hero-right">
                    <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" /> 
                   <img src="assets/img/images/girl4.png" alt="Online Accounting and Bookkeeping Service" />
                 </div>
           
               </div>
             </div>
           </div>


            {/* <div className="space60 bg-white"></div> */}
            <div className="space40"></div>

            <div className="pricing-area pricing2 inner-font-1 inner-price">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <h2 className="aos-init aos-animate text-center">Plans</h2>
                            </div>
                        </div>
                        <div className="col-12 text-center">


                            <div className={`plan-toggle-wrap ${isChecked ? '' : 'active'}`}>
                                <div className="toggle-inner">
                                    <input
                                        id="ce-toggle"
                                        type="checkbox"
                                        checked={isChecked}
                                        onChange={handleToggleChange}
                                    />
                                    <span className="custom-toggle"></span>
                                    <div className="t-month">
                                        <h4>With Inventory</h4>
                                    </div>
                                    <div className="t-year">
                                        <h4>Without Inventory</h4>
                                    </div>
                                </div>
                            </div>
                            {/* <p className="pd-text text-center">Please select annual Transactions:</p> */}

                        </div>
                    </div>

                    <div className="tab-content">

                        <div id="monthly" style={{ display: isChecked ? "block" : "none" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        {/* <div className="price-heading">
                                            <select id="dropdown" onChange={handleChange}>
                                                <option value="option1">0 to 500 Transactions</option>
                                                <option value="option2">500 to 1200 Transactions</option>
                                                <option value="option3">1200 to 2500 Transactions</option>
                                                <option value="option4">2500 to 5000 Transactions</option>
                                                <option value="option5">5000 to 7500 Transactions</option>
                                                <option value="option5">More Than 7500</option>


                                            </select>
                                        </div> */}
                                        &nbsp;

                                        {selectedOption === "option1" && (<div className="box-container" id="option1-boxes">
                                            <div className="container">
                                                <div className="row box-center">

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanBasic
                                                            title="Basic"
                                                            tenures={tenures} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanPro
                                                            title="Pro"
                                                            tenures={tenures1} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>)}
                                        {selectedOption === "option2" && (<div className="box-container" id="option2-boxes">
                                            <div className="container">
                                                <div className="row box-center">

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanBasic
                                                            title="Basic"
                                                            tenures={tenures2} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanPro
                                                            title="Pro"
                                                            tenures={tenures3} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>)}

                                        {selectedOption === "option3" && (<div className="box-container" id="option3-boxes">
                                            <div className="container">
                                                <div className="row box-center">

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanBasic
                                                            title="Basic"
                                                            tenures={tenures4} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanPro
                                                            title="Pro"
                                                            tenures={tenures5} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>)}
                                        {selectedOption === "option4" && (<div className="box-container" id="option4-boxes">
                                            <div className="container">
                                                <div className="row box-center">

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanBasic
                                                            title="Basic"
                                                            tenures={tenures6} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanPro
                                                            title="Pro"
                                                            tenures={tenures7} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>)}
                                        {selectedOption === "option5" && (<div className="box-container" id="option5-boxes">
                                            <div className="container">
                                                <div className="row box-center">

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanBasic
                                                            title="Basic"
                                                            tenures={tenures8} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanPro
                                                            title="Pro"
                                                            tenures={tenures9} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>)}

                                    </div>
                                </div>
                                <div className="space20"></div>

                            </div>
                        </div>



                        <div id="yearly" style={{ display: isChecked ? "none" : "block" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="price-heading">
                                            <select id="dropdown" onChange={handleChange}>
                                                <option value="option1">0 to 500 Transactions</option>
                                                <option value="option2">500 to 1200 Transactions</option>
                                                <option value="option3">1200 to 2500 Transactions</option>
                                                <option value="option4">2500 to 5000 Transactions</option>
                                                <option value="option5">5000 to 7500 Transactions</option>
                                                <option value="option5">More Than 7500</option>


                                            </select>
                                        </div>
                                        &nbsp;

                                        {selectedOption === "option1" && (<div className="box-container" id="option1-boxes">
                                            <div className="container">
                                                <div className="row box-center">

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanBasic
                                                            title="Basic"
                                                            tenures={tenures00} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanPro
                                                            title="Pro"
                                                            tenures={tenures01} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>)}
                                        {selectedOption === "option2" && (<div className="box-container" id="option2-boxes">
                                            <div className="container">
                                                <div className="row box-center">

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanBasic
                                                            title="Basic"
                                                            tenures={tenures02} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanPro
                                                            title="Pro"
                                                            tenures={tenures03} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>)}

                                        {selectedOption === "option3" && (<div className="box-container" id="option3-boxes">
                                            <div className="container">
                                                <div className="row box-center">

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanBasic
                                                            title="Basic"
                                                            tenures={tenures04} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanPro
                                                            title="Pro"
                                                            tenures={tenures05} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>)}
                                        {selectedOption === "option4" && (<div className="box-container" id="option4-boxes">
                                            <div className="container">
                                                <div className="row box-center">

                                                    <div className="col-md-3 col-sm-6">
                                                        <PricingPlanBasic
                                                            title="Basic"
                                                            tenures={tenures06} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                    <div className="col-md-3 col-sm-6">
                                                        <PricingPlanPro
                                                            title="Pro"
                                                            tenures={tenures07} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>)}
                                        {selectedOption === "option5" && (<div className="box-container" id="option5-boxes">
                                            <div className="container">
                                                <div className="row box-center">

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanBasic
                                                            title="Basic"
                                                            tenures={tenures08} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                    <div className="col-md-3 col-sm-6">

                                                        <PricingPlanPro
                                                            title="Pro"
                                                            tenures={tenures09} onChange={handleToggleChange}

                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>)}

                                    </div>
                                </div>
                                <div className="space20"></div>

                            </div>
                        </div>

                    </div>


                    <div className="space80"></div>

                </div>
            </div>
            <div className="space40"></div>
            <div className="home4-counters">
                <div className="container">

                    <div className="space20"></div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <div className="space20"></div>
                                <h2 className="text-center">Benefits of Online Bookkeeping Services </h2>

                            </div>
                        </div>
                    </div>
                    <div className="space30"></div>
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="service6-box s-box">
                                <div className="box-img">
                                    <div className="service-box-icon box-icon">
                                        <img src="assets/img/icons/service6-icon1.png" alt="" />
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><a href="single-service-1.html" className="font-f-7">Improved and Efficient work</a></h4>
                                    <p className="font-f-7">Our online bookkeeping service streamlines your business accounting, making it more efficient and allowing you to focus on delivering greater productivity and fostering business growth.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="service6-box s-box">
                                <div className="box-img">
                                    <div className="service-box-icon box-icon">
                                        <img src="assets/img/icons/service6-icon2.png" alt="" />
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><a href="single-service-1.html" className="font-f-7">Easy Planning for Future Tasks</a></h4>
                                    <p className="font-f-7">Our online bookkeeping service streamlines your business’s accounting, providing easy management and helping you develop a roadmap tailored to your needs. You can concentrate on expanding your business while we handle your accounting.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="service6-box s-box">
                                <div className="box-img">
                                    <div className="service-box-icon box-icon">
                                        <img src="assets/img/icons/service6-icon3.png" alt="" />
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><a href="single-service-1.html" className="font-f-7">Updated Software Support</a></h4>
                                    <p className="font-f-7">In today’s digital age, technology evolves rapidly. Our online bookkeeping service provides you with the latest software to manage your business data seamlessly, even if you’re not highly familiar with accounting.</p>
                                </div>
                            </div>
                        </div>



                        <div className="col-lg-4">
                            <div className="service6-box s-box">
                                <div className="box-img">
                                    <div className="service-box-icon box-icon">
                                        <img src="assets/img/icons/service6-icon5.png" alt="" />
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><a href="single-service-1.html" className="font-f-7">Best Online Support</a></h4>
                                    <p className="font-f-7">Our virtual support system keeps you informed with real-time updates on your work. No matter where you are, simply use your mobile or any digital device to access up-to-the-minute information about your accounting, anytime and anywhere.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="service6-box s-box">
                                <div className="box-img">
                                    <div className="service-box-icon box-icon">
                                        <img src="assets/img/icons/service6-icon6.png" alt="" />
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><a href="single-service-1.html" className="font-f-7">Fast and Accurate Invoice</a></h4>
                                    <p className="font-f-7">Our online bookkeeping service generates invoices quickly and without errors, ensuring that your accounting data remains accurate and easy to understand. This not only saves time but also contributes to the growth of your business.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="service6-box s-box">
                                <div className="box-img">
                                    <div className="service-box-icon box-icon">
                                        <img src="assets/img/icons/service6-icon4.png" alt="" />
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><a href="single-service-1.html" className="font-f-7">Expert Support and Guidance</a></h4>
                                    <p className="font-f-7">Dm2Legal's online bookkeeping service is backed by a team of skilled, experienced, and dedicated professionals who provide top-notch support and ensure the best results for your accounting needs.</p>
                                </div>
                            </div>
                        </div>


                    </div>


                    <div className="row">
                        <div className="col-lg-12">

                           
                            <div className="hadding7">

                                <div className="space80"></div>
                                <h2 className="text-center">Hiring the Right Online Accountant: Key Considerations  </h2>

                            </div>
                        </div>
                        <div className="space30"></div>
                        <div className="col-lg-12"> <p className="pd-text">Your business needs to hire the right online accountant to support its growth. When selecting an online accountant, there are several important factors to consider.</p></div>
                        <div className="col-lg-7">
                            <div className="space40"></div>
                            <div className="contact6-list doc-list">
                                <ul>

                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Able to manage all financial records</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Knowledge of Tax Returns</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Can help with financial advice and guidance</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Ability to conduct financial analysis and forecasting</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Must hold relevant qualifications and certifications</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Well-versed in secure accounting technology and software</li>

                                </ul>
                            </div>

                        </div>

                        <div className="col-lg-3">

                            <div className="contact6-list doc-list">
                                <img src="assets/img/images/Hiring-the-Right-Online-Accountant-Key-Considerations.png" alt="" />
                            </div>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">

                                <div className="space40"></div>
                                <h2 className="text-center">How Online Accounting Enhances Business Efficiency  </h2>

                            </div>
                        </div>
                        <div className="space30"></div>

                        <div className="col-lg-7">
                            <div className="space20"></div>
                            <p className="pd-text">All important data of your company needs to be managed, yet it is often the most overlooked aspect. To ensure a smooth workflow, proper accounting is essential. It helps you manage all your financial data efficiently, which ultimately contributes to the growth of your business.</p>
                           
                            <p className="pd-text">By effectively managing your company’s accounting, you will gain valuable insights into future plans for your business. Proper accounting services streamline your company’s financial processes, reducing manual data entry and minimizing errors.</p>
                           
                            <p className="pd-text">This process creates a systematic, more accurate, and comprehensive record of all the financial transactions carried out by your company. Therefore, choosing Dm2Legal's online accounting service for your business will not only enhance its efficiency but also improve cash flow.</p>
                        </div>

                        <div className="col-lg-5">

                            <div className="contact6-list doc-list">
                                <img src="assets/img/images/How-Online-Accounting-Enhances-Business-Efficiency.jpg" alt="" />
                            </div>
                        </div>

                    </div>
                                            

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <h2 className="text-center">Online Accounting</h2>
                                <div className="space10"></div>
                                <p className="pd-text text-center"> Documents required for Online Accounting:-</p>

                            </div>
                        </div>
                        <div className="col-lg-6">

                            <div className="contact6-list doc-list">
                                <img src="assets/img/images/Documents.png" alt="" />
                            </div>


                        </div>
                        <div className="col-lg-6">
                            <div className="single-price">
                                <div className="price-heading">
                                    <h4 className="text-center">Documents Required</h4>


                                </div>
                                <div className="price-body">
                                    <ul>

                                        <p>Monthly:</p>
                                        <ul>

                                            <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank Statement</li>
                                            <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Sales Bills / Service Bills</li>
                                            <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Purchase Bills</li>
                                            <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; All Expenses (Bills / Vouchers)</li>
                                            <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; All Incomes (Details / Documents)</li>
                                        </ul>

                                        <div className="space30"></div>
                                        <p>With Inventory:</p>
                                        <ul>
                                            <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Stock Summary as on Last 31st March</li>
                                            <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp;All Loan Statements</li>
                                            <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Previous Year Balance Sheet / Audit Report</li>
                                            <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp;Previous Year Tally Data</li>
                                            <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Assets Purchase Bill</li>
                                        </ul>



                                    </ul>

                                </div>
                            </div>
                        </div>


                        <div className="space30"></div>
                    </div>

                </div>
            </div>

            


            <div className="service-binifits9 sp0 last-section" id="service2" >
                <div className="space50"></div>
                <div className="container">

                    <div className="row">
                        <div className="col-lg-12 ">
                            <div className="hadding7">
                                <h2 className="text-center">Understanding Online Bookkeeping and Accounting Process </h2>


                                <div className="partnership-deade-section">
                                    <div className="space40"></div>



                                    <ul className="disc-list">

                                        <li><h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Book the service and complete the form by providing all the necessary details.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li><h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Our accounting professionals and experts will review all the details and verify the documents you have submitted.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Once all the submitted documents and information are successfully verified, our experts will reconcile your accounts and complete the necessary details.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Once the submission is successfully completed, our team of expert and qualified accountants will begin preparing your accounts online.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li><h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                                            <span>Afterward, our expert will contact you to inform you of the successful completion of your accounts.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                    </ul>

                                    <div className="space50"></div>
                                </div>

                            </div>

                        </div>


                    </div>
                </div>
            </div>

            {/* <!--=====testimonial start=======--> */}

            <div className="tes7 sp2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">

                                            
                                <h2 className="text-center">Dm2Legal's Expert Online Accounting Services  </h2>
                                <div className="space40"></div>
                                <p className="pd-text">Dm2Legal’s online accounting services offer comprehensive financial planning tailored to your needs. Combining advanced accounting software with expert guidance, we ensure accuracy and efficiency. Key features of our expert accounting services include:</p>

                            </div>
                        </div>
                        <div className="space30"></div>

                        <div className="col-lg-7">
                            <div className="contact6-list doc-list">
                                <ul>

                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Accessibility of your data from anywhere</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Get the up-to-date financial position of your business</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Have a well-organized accounting of your business transaction</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> By opting for Dm2Legal you will minimize the risk of errors</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Online Accounting and Bookkeeping Services by Experts</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Ensure compliance with regulatory standards</li>
                                    <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Collaborative Approach and efficient financial management</li>

                                </ul>
                            </div>

                        </div>

                        <div className="col-lg-5">

                            <div className="contact6-list doc-list">
                                <img src="assets/img/images/partnership-deed-image.jpg" alt="" />
                            </div>
                        </div>

                    </div>
                    <div className="row">

                        <div className="col-12">
                            <div className="faq-items" id="masonry-grid">
                                <div className="mesonry-item general single-price-list">
                                    <div className="faqs inner-faq">
                                        <h2 className="text-center" >FAQs on Online Accounting</h2>
                                        <div className="space30"></div>


                                        <div id="general">


                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(1)}
                                                >
                                                    Q1: What does Online Accounting mean?
                                                    <span>
                                                        {activeQuestion === 1 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    Online accounting refers to using cloud-based software to manage financial transactions and business records. It allows businesses to track income, expenses, generate reports, and manage bookkeeping remotely, providing easy access and real-time updates from any location. </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(2)}
                                                >
                                                    Q2: What documents are needed for using an online accounting service?
                                                    <span>
                                                        {activeQuestion === 2 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                        The required documents depend on your business needs and may include sales and purchase invoices, payment vouchers, bank statements, and other relevant records.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(3)}
                                                >
                                                    Q3: Is online accounting secure for sharing financial data?
                                                    <span>
                                                        {activeQuestion === 3 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">Yes, online accounting services are secure, as they use encryption and other security measures to protect your data. However, always choose trusted platforms with strong security features.</p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(4)}
                                                >
                                                    Q4: What are the advantages of online accounting services?
                                                    <span>
                                                        {activeQuestion === 4 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    Online accounting services offer real-time access, easy collaboration, automated processes, cost-efficiency, and enhanced security, simplifying financial management for businesses.</p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(5)}
                                                >
                                                    Q5: Is online accounting expensive?
                                                    <span>
                                                        {activeQuestion === 5 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    Online accounting can be cost-effective, with flexible pricing plans depending on the business size and features needed, often cheaper than traditional accounting services.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(6)}
                                                >
                                                    Q6: How does online accounting work?
                                                    <span>
                                                        {activeQuestion === 6 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    Online accounting services allow businesses to manage their finances through cloud-based software, where users can track expenses, generate invoices, and monitor financial reports, all accessible remotely and in real time.                                                    </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(7)}
                                                >
                                                    Q7: What is required for online accounting services?
                                                    <span>
                                                        {activeQuestion === 7 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    To use online accounting services, you need a stable internet connection, access to cloud-based accounting software, and necessary financial documents like invoices, receipts, bank statements, and other accounting records.                                                    </p>
                                                </div>
                                            </div>

                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(8)}
                                                >
                                                    Q8: Can I customize online accounting services?
                                                    <span>
                                                        {activeQuestion === 8 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                        With Dm2Legal, you can easily tailor your online accounting service to meet your specific needs and receive personalized expert support.
                                                    </p>
                                                </div>
                                            </div>









                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>



                </div>
            </div>

            <Testimonials />

           
            <div className=" last-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 m-auto text-center">

                            <div className="hadding7">

                              
                                <h2>Why Choose Dm2Legal for Online Accounting </h2>
                            </div>

                        </div>
                    </div>
                    <div className="space30"></div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>1</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/reg.svg" alt="" /></span><a href="#" >Convenient Registration</a></h4>
                                    <p>Dm2Legal offers top-notch online accounting services to meet your business needs. You can easily register through our website or mobile app by completing a simple form. Once your registration is complete, our team will get in touch with you and provide all the necessary details.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>2</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/online.svg" alt="" /></span><a href="single-service-1.html" >Best Online Platform</a></h4>
                                    <p>Dm2Legal boasts the largest online client base, making us one of the leading online legal platforms in India. No matter where you are, if you're looking to purchase our Online Accounting service, simply book the service online.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>3</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/customer.svg" alt="" /></span><a href="single-service-1.html" >Best Legal Support</a></h4>
                                    <p>The Dm2Legal team is renowned for offering comprehensive support and assistance to our clients. We provide top-notch accounting service support once you book our service, and we highly value your feedback.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>4</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                                    <p>With over 10 years of experience in the accounting industry, we are well-equipped to assist you. By choosing us as your online accountant, you will benefit from working with seasoned experts, all from the comfort of your home.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>5</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >On-time Service</a></h4>
                                    <p>Our team is committed to delivering timely service without any unnecessary delays. We understand the value of your time and ensure that you receive effective and efficient service when you need it.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>6</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/friendly.svg" alt="" /></span><a href="single-service-1.html" >Pocket-friendly Legal Services</a></h4>
                                    <p>We provide cost-effective and budget-friendly online accounting services that won’t strain your finances. With every investment you make in our services, we ensure you receive the best deal available in the market.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!--=====service end=======--> */}
            <div className="space80"></div>

            <WhatsAppScrollButton />

            <Footer />

            <CircularScrollProgress />





        </>
    );
}
export default Onlineaccounting;
